import React, { FC, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { AnimatedShape, Box } from '@altermaind/web/ui';
import { Slider } from '@/_shared/components/Slider';
import { getNewContentsCall } from '../../state';
import { ContentsSkeleton } from '../ContentsSkeleton';
import { ContentToCard } from '../ContentToCard';

export const NewContents: FC = () => {
  const t = useTranslations('trainingHardSkills.sections.newContents');
  const {
    success: successGetNewContents,
    execute: executeGetNewContents,
    loading: loadingGetNewContents,
    data,
  } = getNewContentsCall.hook();

  useEffect(() => {
    executeGetNewContents({
      length: 10,
    });
  }, [executeGetNewContents]);

  if (successGetNewContents && !data?.length) {
    return null;
  }

  return (
    <Box mb='m'>
      {loadingGetNewContents ? (
        <>
          <AnimatedShape width='30%' height={25} mb='xxs' />
          <AnimatedShape width='50%' height={15} mb='m' />
          <ContentsSkeleton halfHeightLayout={false} />
        </>
      ) : null}
      {!loadingGetNewContents && data && data.length > 0 ? (
        <Slider.SliderBottomRightArrow title={t('title')} description={t('subTitle')}>
          {data?.map(content => (
            <ContentToCard content={content} key={content.id} />
          ))}
        </Slider.SliderBottomRightArrow>
      ) : null}
    </Box>
  );
};
